import { Box, BoxProps, ButtonProps, Heading, HeadingProps, HStack, Stack, Text, VStack } from "@chakra-ui/react";
import { IconButton } from "components/Button/IconButton";
import Logo from "components/Logo/Logo";

interface ActionBarProps extends BoxProps {
  title: string;
  showLogo?: boolean;
  _title?: HeadingProps;
  onBackClick?: () => void;
  onMoreClick?: () => void;
  _back?: ButtonProps;
  _more?: ButtonProps;
  hideMore?: boolean;
  _content?: BoxProps;
  _textProp?: BoxProps;
}

export function ActionBar(props: ActionBarProps) {
  const {
    children,
    showLogo = false,
    _title,
    title,
    onBackClick,
    onMoreClick,
    _back,
    _more,
    _content,
    _textProp,
    hideMore,
    ...xprops
  } = props;

  return (
    <Stack alignItems="center" {...xprops}>
      <HStack w="100%" justifyContent="space-between">
        <IconButton
          onClick={onBackClick}
          aria-label="back button"
          icon="arrowRight"
          transform="rotate(-180deg)"
          _active={{ transform: "rotate(-168deg)" }}
          {..._back}
        />
        <VStack>
          {!!showLogo && (
            <Logo
              fontSize="54px"
              // mb={{ sm: "12px", "2sm": "52px" }}
              _icon={{ h: "40px" }}
              _name={{ display: "none" }}
              color="primary.default"
            />
          )}
          <Heading as="h4" size="sm" {..._title}>
            {title}
          </Heading>
        </VStack>

        <Box>{hideMore ? <Box></Box> : <IconButton aria-label="back button" icon="moreVert" {..._more} />}</Box>
      </HStack>

      {!!children && (
        <VStack w="100%" maxW="calc(100% - 80px)" mx="auto" mt="20px !important" {..._content}>
          <Text fontSize="14px" textAlign="center" lineHeight="18px" fontWeight="500" {..._textProp}>
            {children}
          </Text>
        </VStack>
      )}
    </Stack>
  );
}
